import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Modal, Button, Collapse } from "react-bootstrap";
import UploadImage from "../../components/pgi/UploadImage";
import Gallery from "react-grid-gallery";
import toast from "react-hot-toast";

//https://github.com/benhowell/react-grid-gallery#image-options
/*íconos */
import {
  DoneOutlined,
  AddPhotoAlternateOutlined,
  CheckCircleOutline,
  DeleteForeverOutlined,
  AddOutlined,
  PhotoOutlined
} from "@mui/icons-material";
import RecursoGallery from "../../components/pgi/RecursoGallery";
import useImage from "../../hooks/useImage";
import useProduct from "../../hooks/useProduct";

const GaleriaPgi = () => {
  const [showEditGaleria, setShowEditGaleria] = useState(false);
  const handleClose = () => setShowEditGaleria(false);
  const handleShow = () => setShowEditGaleria(true);
  //const [open, setOpen] = useState (false);
  const [open, setOpen] = useState(true);
  const [openProducts, setOpenProducts] = useState(false);
  const [openAlbums, setOpenAlbums] = useState(false);

  /**MODAL NUEVO/CARGAR ALBUM */
  const [showAlbum, setShowAlbum] = useState(false);
  const handleCloseAlbum = () => setShowAlbum(false);
  const handleShowAlbum = () => setShowAlbum(true);

  /**MODAL NUEVO/CARGAR ALBUM */
  const [deleteAlbum, setDeleteAlbum] = useState(false);
  const handleCloseDeleteAlbum = () => setDeleteAlbum(false);
  const handleDeleteAlbum = () => setDeleteAlbum(true);

  const {
    images,
    setImages,
    getImagesByBody,
    addAlbumToImages,
    handleStateToDelete,
    addExistingAlbumToImages,
    handleAlbumDelete,
    setFilteredImages,
    eliminarCategoriaDuplicados,
    filteredImages,
    imagesAct
  } = useImage();

  const { products, setProducts } = useProduct();
  const [selectedImage, setSelectedImage] = useState(null);
  const [multiSelect, setMultiSelect] = useState([]);
  const [filterArray, setFilterArray] = useState([]);
  const [albumes, setAlbumes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setProducts(
      products?.sort(
        (a, b) => a.position?.find((obj) => obj)?.product - b.position?.find((obj) => obj)?.product
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);

  const handleImageEdit = ({ target }) => {
    setSelectedImage(...images.filter((image) => image.src === target.src));
    handleShow();
  };

  const handleAlbumFilter = ({ target }) => {
    const { value, checked } = target;

    if (checked) {
      setFilterArray([...filterArray, value]);
    } else {
      setFilterArray(filterArray.filter((item) => item !== value));
    }
  };

  useEffect(() => {
    if (filterArray.length > 0) {
      const data = images
        .filter(
          (data) =>
            filterArray.includes(data.product) ||
            filterArray.includes(data.category) ||
            data.album.some((item) => filterArray.includes(item))
        )
        .map((filtered) => {
          return filtered;
        });

      setFilteredImages(data);
    } else {
      const data2 = images;
      setFilteredImages(data2);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterArray]);

  /* const callBell = document.getElementById('callbell-iframe')
    useEffect(() => {
      callBell && document.getElementById('callbell-iframe').classList.add('d-none')
    }, [callBell]) */

  useEffect(() => {
    getImagesByBody().then((res) => {
      const mapeo = res.map((res) => {
        return {
          src: res.url,
          thumbnail: res.url,
          thumbnailWidth: 320,
          thumbnailHeight: 212,
          caption: res.name,
          id: res.id,
          title: res.title,
          description: res.description,
          alt: res.alt,
          category: res.category,
          product: res.product,
          state: true,
          tags: res.tags
            ? res.tags.map((item) => {
                return {
                  value: item,
                  title: item
                };
              })
            : [],
          album: res.album,
          isSelected: false
        };
      });
      setImages(mapeo);
      setFilteredImages(mapeo);
      setMultiSelect([]);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagesAct]);

  useEffect(() => {
    let albumes = [];
    let array = [];

    images.map((image) => {
      if (image.album !== undefined) {
        image.album.map((album) => {
          albumes.push(album);
          return albumes;
        });
      }
      return image;
    });
    array = [...new Set(albumes)];
    setAlbumes(array);
  }, [images]);

  useEffect(() => {
    loading === true &&
      toast.success("Click secundario sobre la imagen para copiar la URL", {
        duration: 6000
      });
  }, [loading]);

  const onSelectImage = (index, image) => {
    const img = images.find((img) => img.id === image.id);
    if (img.isSelected) {
      img.isSelected = false;
      setMultiSelect(
        multiSelect.filter((item) => item !== multiSelect.find((obj) => obj.id === image.id))
      );
    } else {
      img.isSelected = true;
      setMultiSelect([...multiSelect, { id: img.id, album: img.album }]);
    }
  };

  useEffect(() => {
    setLoading(true);
    document.title = "Galería de Recursos | PGI Tensolite";
  }, []);

  useEffect(() => {
    const collectionGaleryImg = Array.from(
      document.getElementsByClassName("ReactGridGallery_tile")
    );

    collectionGaleryImg.map((item) => {
      const childItem = item.children[4].children[0];
      childItem.addEventListener("mousedown", (e) => {
        if (e.button === 2) {
          const aux = `${e.target.currentSrc}`;
          navigator.clipboard.writeText(aux);
          toast.success("URL copiada con exito");
        }
      });
    });
  }, [images]);

  const categoryOptions = eliminarCategoriaDuplicados(images).map((item) => item.label);

  ////////////////////// ********************************************************* ////////////////////////

  return (
    <div id="wrapperEditGaleria" className="wrapperPgi">
      <div className="my-5 container containerPgi">
        <header>
          <h1>Galería Multimedia</h1>
        </header>
        <section className="wrapperViewGalery">
          <div id="pgi__galeria-filter">
            <UploadImage selectedImage={selectedImage ? selectedImage : null} allImages={images} />
            {/* filtro categorias */}
            <section id="categoryGalery">
              <h3
                onClick={() => setOpen(!open)}
                aria-controls="category-collapse"
                aria-expanded={open}
              >
                Categorías (4)
              </h3>
              <Collapse in={open}>
                <div id="category-collapse">
                  {categoryOptions.map((id, index) => (
                    <Form.Check
                      type="checkbox"
                      key={index}
                      id={`id${id}`}
                      label={`${id}`}
                      name={"category"}
                      value={id}
                      onChange={handleAlbumFilter}
                    />
                  ))}
                </div>
              </Collapse>
            </section>
            {/* filtro productos */}
            <section id="productsGalery">
              <h3
                onClick={() => setOpenProducts(!openProducts)}
                aria-controls="products-collapse"
                aria-expanded={openProducts}
              >
                Productos (3)
              </h3>
              <Collapse in={openProducts}>
                <div id="products-collapse">
                  <ul>
                    {products?.map(
                      (product, index) =>
                        product?.type === "productoLinea" &&
                        product?.deleted !== true &&
                        product?.visible === true && (
                          <Form.Check
                            type="checkbox"
                            id={`id${product.title}`}
                            key={index}
                            label={`${product.title}`}
                            name={"product"}
                            value={product.title}
                            onChange={handleAlbumFilter}
                          />
                        )
                    )}
                  </ul>
                </div>
              </Collapse>
            </section>
            <section id="albumesGalery d-flex">
              <h3
                onClick={() => setOpenAlbums(!openAlbums)}
                aria-controls="products-collapse"
                aria-expanded={openAlbums}
              >
                Álbumes ({albumes.length})
              </h3>
              <Collapse in={openAlbums}>
                <div id="products-collapse">
                  <Form>
                    {albumes.map((id, index) => (
                      <Form.Check
                        className="pgi__editAlbum"
                        type="checkbox"
                        id={`id${id}`}
                        key={index}
                        label={`${id}`}
                        name={"album"}
                        value={id}
                        onChange={handleAlbumFilter}
                      />
                    ))}
                  </Form>
                </div>
              </Collapse>
            </section>
          </div>
          {/* VISTA DE FOTOS/ALBUMES */}
          <div id="pgi__galeria-view">
            {multiSelect.length > 0 ? (
              <div id="pgi__galeria-album">
                <div className="pgi__info-second">
                  <CheckCircleOutline fontSize="small" /> {multiSelect.length} elementos
                  seleccionados
                </div>
                <button type="button" onClick={handleShowAlbum}>
                  <AddPhotoAlternateOutlined /> <div className="tooltips">Añadir al álbum</div>
                </button>
                <button type="button" onClick={handleDeleteAlbum}>
                  <DeleteForeverOutlined /> <div className="tooltips">Eliminar</div>
                </button>
              </div>
            ) : null}
            {/* ARTICLE X CATEGORÍA / ALBUM */}
            <article className="pgi__album-category">
              <h2>
                Todos <i>({filteredImages.length})</i>
              </h2>
              <Gallery
                images={filteredImages}
                imageCountSeparator=" de "
                //SETEAR SEGUN FUNCIONES NECESARIAS
                enableImageSelection={true}
                onSelectImage={onSelectImage}
                backdropClosesModal={true}
                showLightboxThumbnails={true}
                onClickImage={handleImageEdit}
              />
            </article>
          </div>
          {/* end #pgi__galeria-view */}
        </section>
      </div>

      {/* OFFCANVAS SETTING HOME*/}
      <Offcanvas
        show={showEditGaleria}
        onHide={handleClose}
        placement="end"
        scroll
        enforceFocus
        backdrop={false}
        className="basePgi__pgi"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Información de Recurso</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/**FORM UP/EDIT recurso */}
          <RecursoGallery selectedImage={selectedImage ? selectedImage : null} allImages={images} />
        </Offcanvas.Body>
      </Offcanvas>
      {/*offC slides */}

      {/*MODALS BUTTONES SELECTED */}
      <Modal show={showAlbum} onHide={handleCloseAlbum}>
        <Modal.Header closeButton>
          <Modal.Title>Añadir a...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="addPhotoTo" className="pgi__info-second">
            <CheckCircleOutline fontSize="small" /> {multiSelect.length} elementos seleccionados
          </div>
          <ul className="pgi__addToAlbum">
            <div className="pgi__album-category">
              <h2>Nuevo Álbum</h2>
            </div>
            <li>
              <form id="addNewAlbum" onSubmit={(event) => addAlbumToImages(event, multiSelect)}>
                <AddOutlined />
                <input
                  type="text"
                  required
                  className="form-control"
                  name="newAlbum"
                  id="newAlbum"
                  placeholder="Añade un título"
                />
                <button type="submit">
                  <DoneOutlined />
                </button>
              </form>
            </li>
            <div className="pgi__album-category">
              <h2>Álbumes</h2>
            </div>
            {albumes.map((id, index) => {
              return (
                <li key={index} className="pgi__addToAlbums">
                  <form id="addToAlbum">
                    <figure>
                      <div className="pgi__thumb">
                        <video src={images[1]?.thumbnail} alt="" />
                      </div>
                      <figcaption>
                        {id}{" "}
                        <span>
                          <PhotoOutlined />
                        </span>
                      </figcaption>
                    </figure>
                    <button type="button" onClick={() => addExistingAlbumToImages(id, multiSelect)}>
                      <DoneOutlined />
                    </button>
                  </form>
                </li>
              );
            })}
          </ul>
        </Modal.Body>
      </Modal>

      {/*MODALS DELETE SELECTED */}
      <Modal id="deleteRecursos" show={deleteAlbum} onHide={handleCloseDeleteAlbum}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar de...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="addPhotoTo" className="pgi__info-second">
            <CheckCircleOutline fontSize="small" /> {multiSelect.length} elementos seleccionados
          </div>
          <ul className="pgi__addToAlbum">
            <div className="pgi__album-category">
              <h2>Recursos Multimedia </h2>
            </div>
            <li>
              <form
                id="deleteRecursoAll"
                onSubmit={(event) => handleStateToDelete(event, multiSelect)}
              >
                <div>
                  <DeleteForeverOutlined /> Base de Datos
                </div>
                <button type="submit">
                  <DoneOutlined />
                </button>
              </form>
            </li>
            <div className="pgi__album-category">
              <h2>Álbumes</h2>
            </div>
            {albumes.map((id, index) => {
              return (
                <li key={index} className="pgi__addToAlbums">
                  <form id="addToAlbum">
                    <figure>
                      <div className="pgi__thumb">
                        <video src={images[1]?.thumbnail} alt="" />
                      </div>
                      <figcaption>
                        {id}{" "}
                        <span>
                          <PhotoOutlined />
                        </span>
                      </figcaption>
                    </figure>
                    <button type="button" onClick={() => handleAlbumDelete(id, multiSelect)}>
                      <DoneOutlined />
                    </button>
                  </form>
                </li>
              );
            })}
          </ul>
        </Modal.Body>
      </Modal>

      {/*************************** */}
    </div>
  );
};

export default GaleriaPgi;
